import React from "react";
import { PrinterIcon } from "lucide-react";
import { Section, SectionHeading } from "../Section";
import { tools } from "../../data/landing";
export function ToolsSection() {
  return <Section tone="white" narrow cta="I want access to the complete system" data-id="element-285" data-mp="1ws77ao89c351">
      <SectionHeading eyebrow="Ready to print" title="And I've included these professional case-review tools" data-id="element-286" data-mp="1wub990mlis2o" />

      <ul className="mt-10 divide-y divide-line overflow-hidden rounded-3xl border border-line bg-cream" data-id="element-287" data-mp="1nzwynbd0g5pw">
        {tools.map((t, i) => <li key={t.title} className="flex gap-4 p-5 md:p-6" data-id="element-288" data-mp="1sr59mbtznz56" data-mpi={i}>
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-ink font-serif text-lg font-bold text-white" data-id="element-289" data-mp="1e1pkt1e0q3s4">
              {i + 1}
            </span>
            <div data-id="element-290" data-mp="150re2bc73i5u">
              <h3 className="font-serif text-lg font-bold leading-snug text-ink md:text-xl" data-id="element-291" data-mp="15098up7k1tls">{t.title}</h3>
              <p className="mt-1 text-[16px] leading-relaxed text-inkSoft" data-id="element-292" data-mp="192w4703fpwnq">{t.text}</p>
            </div>
          </li>)}
      </ul>

      <p className="mt-6 flex items-center justify-center gap-2 text-center text-[16px] font-semibold text-ink" data-id="element-293" data-mp="1rr6te2fndt18">
        <PrinterIcon className="h-5 w-5 shrink-0 text-rose" aria-hidden="true" data-id="element-294" data-mp="1mvri9i90yb8i" />
        Everything is designed to be downloaded, printed and reused.
      </p>
    </Section>;
}